import { Alert } from 'antd';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import apiCalls from 'src/api/apiCalls';
import CustomerTransactionsGrid from '../../customerDetails/customerTransactions/grid'
import CustomerTranasactionFilters from '../../customerDetails/customerTransactions/filters'
const CustomerTransactions = () => {
  const [filterValues, setFilterValues] = useState({"transactionType": "All"});
  const [typeLu, setTypeLu] = useState([]);
  const [error, setError] = useState(null);
  const shouldLog = useRef(true);
  const [isExcelExport, setIsExcelExport] = useState(false);
  const refreshRef = useRef();
 
  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
      getTransactionLookup();
    }
  }, [])
 
    const getTransactionLookup = async () => {
    try {
      setError(null)
      const response = await apiCalls.getTransTypelookupData(`KycService/TxTypeLookup`)
      if (response?.ok) {
        setTypeLu(response.data?.TxTypeLookup);
        setError(null)
      }
      else {
        setError(apiCalls.isErrorDispaly(response))
      }
    }
    catch (error) {
      setError(apiCalls.isErrorDispaly(error))
    }
  }
  const handleSearch = useCallback((values) => {
    setFilterValues({
      transactionType: values?.transactionType || "All"
    });
  },[])

  const handleExcelExport = useCallback((callback) => {
    setIsExcelExport(callback);
  },[])

  const closeErrorHandler = useCallback(() => {
    setError(null)
  },[])
  
  return (
    <div className=''>
      {error &&
        <div className='mb-4'>
          <Alert
            className='mb-6'
            type="error"
            description={error}
            onClose={closeErrorHandler}
            showIcon
            closable
          />
        </div>
      }
      <CustomerTranasactionFilters handleExcelExport={handleExcelExport} filterObj={handleSearch} filterValues={filterValues} typeLu={typeLu} onloadGrid={refreshRef?.current?.loadGrid}  />
      <CustomerTransactionsGrid filterValues={filterValues} ref={refreshRef} isExcelExport={isExcelExport} />
    </div>
  )
}
export default React.memo(CustomerTransactions);